export function QuoteImageButton({ src, alt, className, imageTestId, onOpen }: {
  src: string; alt: string; className?: string; imageTestId?: string;
  onOpen: (image: { src: string; alt: string }) => void;
}) {
  return <button type="button" className="block w-full cursor-zoom-in rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-bauwerk-teal"
    aria-label={`${alt} vergrößern`} title="Bild vergrößern"
    onClick={(event) => { event.stopPropagation(); onOpen({ src, alt }); }}>
    <img src={src} alt={alt} className={className} data-testid={imageTestId} />
  </button>;
}
